<template>
    <div class="page my-setting">

        <div class="control">
            <van-cell title-class="control-title" title="更换手机号" :value="user.mobile" is-link url="/vant/mobile.html" :to="'my-update-tel'" ></van-cell>
        </div>

        <div class="logout">
            <van-button class="logout" type="danger" color="#D3172E" round size="large" @click="logout">退出登录</van-button>
            <div class="logout-back" @click="$router.push({name:'my'})">
                <img src="/static/img/icon_mycenter_back.svg" style="width: 16px;margin-bottom: -3px" alt="">
                返回上一页
            </div>
        </div>
    </div>
</template>

<script>

    import Interface from "@/util/interface"
    export default {
        name: 'home',
        data() {
            return {
                value: "",
                active: 1,
                user:{}
            }
        },
        methods: {
            fetch(scene) {
                if (scene === 'userinfo') {
                    Interface.getData('get',Interface.user.user_info).then((res)=>{
                        this.user = res.data
                        setTimeout(()=>{this.loading = false},500)
                    })
                }
            },
            logout(){
                Interface.logout()
            }
        },
        created() {
            this.fetch('userinfo')
            Interface.getShareInfo(this,"","","")
        },
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/my/setting/index.vue